module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 9
// module chunks = 1